var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
/**
 * Rectangular button with centered text and a filled background.
 */
const BlockButton = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement("button", Object.assign({}, rest),
        React.createElement("div", null, children)));
};
export default styled(BlockButton) `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: none;
  border-radius: 3px;
  font-family: inherit;
  font-size: 1rem;
  font-family: inherit;
  font-weight: bold;
  padding: 1rem 3rem 1rem 3rem;
  color: #fff;
  background-color: #444;
  box-sizing: border-box;
  overflow: hidden;

  > div {
    z-index: 2;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  /* Darken background when hovered/active */
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color 0.2s;
    z-index: 1;
  }

  &:not(:disabled):hover::after,
  &:not(:disabled):active::after {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
